(() => {
	$(document).ready(() => {
		const modal = $('.modal-cookies');

		if (!$('.modal-cookies').length) return false;

		const btn = modal.find('.accept-cookies');
		const settings = modal.find('.modify-cookies');

		const list = modal.find('.cookies-settings');

		settings.on('click', function (e) {
			e.preventDefault();

			modal.find('.content p').slideToggle(750);

			list.toggleClass('active');
			list.slideToggle(750);
		});

		btn.on('click', function (e) {
			e.preventDefault();

			const data = {
				tracking: list.find('.tracking-box').is(':checked'),
				remarketing: list.find('.remarketing-box').is(':checked'),
				profiling: list.find('.profiling-box').is(':checked')
			}

			Cookies.set('adjt', btoa(JSON.stringify(data)), {expires: 180});

			modal.addClass('close');
			setTimeout(() => modal.remove(), 1000);

			for (let key in data) {
				const el = $('script[data-' + key + ']');

				el.each(function () {
					if (!data[key]) {
						$(this).remove();
						return false;
					}

					const js = document.createElement('script');
					const attrs = this.attributes;

					for (let i = 0; i < attrs.length; i++) {
						if (attrs[i].name == 'data-' + key) continue;
						if (attrs[i].name == 'type') continue;
						js.setAttribute(attrs[i].name, attrs[i].value);
					}

					js.removeAttribute('data-' + key);

					if (js.src.length) document.body.insertAdjacentElement('beforeend', js);

					if (!js.src.length) eval(this.innerHTML);

					$(this).remove();
				});
			}
		});
	});
})();